export default __webpack_public_path__ + "static/media/logout_graphic.d2c60aee.png";